import { NgModule } from '@angular/core';
import { CreateShipmentRoutingModule } from './create-shipment-routing.module';

@NgModule({
  imports: [
    CreateShipmentRoutingModule,
  ]
})
export class CreateShipmentModule { }

